<template>
  <v-navigation-drawer
    v-model="drawer"
    right
    fixed
    temporary
    floating
    clipped
    :touchless="!drawer"
    style="border-top-left-radius: 24px; border-bottom-left-radius: 24px;">
    <!-- touchless 
    
    -->

    <!-- Header -->
    <v-toolbar 
      style="border-top-left-radius: 24px; background-image: linear-gradient(330deg, rgba(216,27,96,1), #eeff41);"
      dark
      dense
      flat>
      <v-toolbar-side-icon @click.stop="drawer = false">
        <v-icon>fas fa-chevron-right</v-icon>
      </v-toolbar-side-icon>
      <v-spacer></v-spacer>

      <div
        class="wevent_icon_wrapper_brand text-xs-center">
        <img
          class="wevent_icon_logo" 
          src="@/assets/TextWeVent_thumbnail_beta.svg" 
          alt="WeVent">
      </div>

      <v-spacer></v-spacer>

      <v-btn 
        icon
        disabled>
        <v-icon>
        </v-icon>
      </v-btn>
    </v-toolbar>

    <!-- <v-content> -->
    <v-toolbar
      dense
      flat>
      <!-- <v-list>
          <v-list-tile>
            <v-list-tile-title class="title"> -->
      <span class="subheading">Settings</span>
      <!-- </v-list-tile-title>
          </v-list-tile>
        </v-list> -->
    </v-toolbar>

    <v-list 
      class="pt-0" 
      dense>
      <v-divider></v-divider>

      <v-list-tile
        v-for="item in items"
        :key="item.title"
        @click="getSelf()[item.method](item.payload)">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <!-- </v-content> -->
  </v-navigation-drawer>
</template>
    

<script>
import { mapState, mapMutations, mapActions } from 'vuex'


export default {
  components: {
    // eslint-disable-next-line
   
  },
  data() {
    return {
      items: [
        { title: 'Profil', icon: 'fas fa-user fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-display' },
        // { title: 'Allgemein', icon: 'fas fa-address-card fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-settings-general' },
        { title: 'Sicherheit und Login', icon: 'fas fa-lock fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-settings-securitylogin' },
        { title: 'Konto verwalten', icon: 'fas fa-user-circle fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-settings-account' },
        { title: 'Was ist WeVent?', icon: 'fas fa-person-sign fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-settings-information' },
        { title: 'Versionsverlauf', icon: 'fas fa-tasks-alt fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-settings-versions' },
        { title: 'Demnächst', icon: 'fas fa-list-alt fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-settings-todo' },
        { title: 'Feedback & Verbesserung', icon: 'fas fa-envelope-open-text fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-settings-feedback' },
        { title: 'Datenschutzerklärung', icon: 'fas fa-book fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-settings-datenschutz' },
        { title: 'Impressum', icon: 'fas fa-paragraph fa-fw', method: 'setSelectedProfileComp', payload: 'app-profile-settings-impressum' },
        { title: 'Logout', icon: 'fas fa-sign-out-alt fa-fw', method: 'logout', payload: null }
      ]
    }
  },

  computed: {
    ...mapState({
      selectedProfileComp: state => state.view_profile.selectedProfileComp
    }),

    drawer: {
      get() {
        return this.$store.state.view_profile.profile_settingsdrawer
      },
      set(value) {
        if (this.$store.state.view_profile.profile_settingsdrawer !== value) {
          this.click_profile_settingsdrawer(value)
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'click_profile_settingsdrawer',
      'setSelectedProfileComp'
    ]),
    ...mapActions([
      'logout'
    ]),
    
    getSelf () {
      return this
    }
    
  }
}
</script>


<style scoped>

.wevent_icon_logo {
  cursor: default;
  height: 28px !important;
  width: auto;
  margin-top: 12px;
  
  filter: invert(1) sepia(1) saturate(1) hue-rotate(175deg);
}
</style>
